/*
 */
import { VisionApplication } from './application';
import { VisionTest } from './test';

/*
(function debugBadImages() {
    const originalSetAttribute = Element.prototype.setAttribute;

    Element.prototype.setAttribute = function (name: string, value: string) {
        if (name.toLowerCase() === 'src' && typeof value === 'string' && value.includes('css/imgs/')) {
            console.error('BAD IMAGE SRC:', value, this);
            console.trace();
            debugger;
        }

        return originalSetAttribute.call(this, name, value);
    };

    const originalSetProperty = CSSStyleDeclaration.prototype.setProperty;

    CSSStyleDeclaration.prototype.setProperty = function (property: string, value: string | null) {
        if (typeof value === 'string' && value.includes('css/imgs/')) {
            console.error('BAD CSS IMAGE:', property, value, this);
            console.trace();
            debugger;
        }

        return originalSetProperty.call(this, property, value);
    };
})();

Object.defineProperty(HTMLImageElement.prototype, 'src', {
    set(value: string) {
        if (value.includes('/css/imgs/')) {
            console.error('BAD IMG SRC PROPERTY:', value, this);
            console.trace();
            debugger;
        }

        this.setAttribute('src', value);
    },
});
*/

const app = VisionApplication.getInstance();
VisionApplication.getInstance();

//VisionTest.getInstance();
